export const iconFontAwesomeMoneyCoins = (
	<i className="fa-solid fa-coins"></i>
);
